module.exports = __webpack_public_path__ + "img/check_01.0db17601.png";